import React, { useContext } from "react"
import { PriceContext } from "../PriceContext"
import { Form } from "react-bootstrap"
import * as styles from "./range.module.scss"

interface PanelProps {
  fixed?: boolean
}

const Range: React.FC<PanelProps> = ({ fixed = false }) => {
  const { calculator, range, setRange, text } = useContext(PriceContext)

  if (!calculator || !Array.isArray(calculator.tiers)) {
    return null
  }

  const currentUsers = calculator.tiers[range]?.users ?? 0
  const isUnlimited = currentUsers === null || currentUsers === 0

  const handleRangeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setRange(Number(e.target.value))
  }

  return (
    <div className={styles.range}>
      <p className={fixed ? `${styles.hideOnFixed} ${styles.rangeDesc}` : styles.rangeDesc}>{text?.range?.about}</p>

      <Form.Range className={styles.inputTariff} value={range} onChange={handleRangeChange} min={0} max={calculator.tiers.length - 1} name="usersIndex" />

      {!isUnlimited ? (
        <p className={fixed ? `${styles.summary}` : styles.summary}>
          до
          <span className={styles.summaryValue}>{currentUsers.toLocaleString("ru-RU")}</span>
          посетителей в месяц
        </p>
      ) : (
        <p className={fixed ? `${styles.summary}` : styles.summary}>
          более
          <span className={styles.summaryValue}>{text?.range?.more}</span>
          посетителей в месяц
        </p>
      )}
    </div>
  )
}

export default Range
